import React, {Component} from "react"

import {
  Window,
  WindowHeader,
  WindowContent,
} from 'react95'

import Icons from "./Icons";

import mapImage from "./assets/map.png.webp";

import { t } from './i18n';

class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true
    };
  }
  componentDidMount() {
    setTimeout(() => {
        this.setState(() => ({visible: false}))
    }, 2000)
    this.centerWindows()
    window.onresize = this.centerWindows
  }
  centerWindows () {
    document.querySelectorAll('.window').forEach((win) => {
      if (win.offsetHeight >= window.innerHeight) {
        win.style.top = '0px'
      } else {
        win.style.top = (window.innerHeight - win.offsetHeight)/2 + 'px'
      }
    })
  }
    
  render() {
    const allTechologies = ['react', 'mysql', 'apache', 'symfony', 'onlinecreation', 'wordpress', 'bootstrap', 'html5', 'js', 'css3', 'vuejs', 'graphicdesign', 'php', 'onlc', 'ios', 'android', 'debianlinux', 'eye', 'france', 'chevron-left', 'chevron-right', 'github', 'linkedin', 'facebook']
    return (
      this.state.visible &&
      <div className="splash-screen windows-container">
        <Window className='window center-window splash-window'>
            <WindowHeader className='window-title' style={{ fontWeight: 'normal', borderWidth: '1px 1px 0 1px', letterSpacing: '-0.12px'}}>
                {t('splashTitle', this.props.lang)}
            </WindowHeader>
            <WindowContent style={{ padding: '0 1px 0 1px', margin: '0'}}>
                <div style={{ backgroundColor: '#fff', padding: '16px 0 16px 0'}}>
                    <div className="blue-text" style={{width: '235px', margin: 'auto', height: '96px'}}>
                        <div className="float-left">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{height: '6em'}}><path d="M32.6 479.7h33.7L32.6 446.2v33.5zM479.4 32.3H32.6V383l94.4 93.8a30 30 0 0 1 2.5 2.8H168V306c0-14.1 10.1-25.6 22.5-25.6s22.5 11.5 22.5 25.6V479.7h39.5a25.8 25.8 0 0 1 2.5-2.8L382.7 350c10.1-10 25.3-11.1 34.1-2.3c8.8 8.7 7.7 23.9-2.4 33.9l-98.7 98.1h163.7V32.3z" fill="currentColor"/></svg>
                        </div> 
                        <div className="logo">
                            <span>Online</span>
                            <span>Creation</span>
                        </div>
                        <div style={{clear: 'both'}}></div>
                    </div>
                </div>
                <div className="gradient-loader"></div>
                <div className="bottom-16" style={{height: '1px', overflow: 'hidden'}}>
                    {allTechologies.map((tech, i) => {
                        return <Icons key={i} icon={tech} />
                    })}
                    <img src={mapImage} alt="Basé à Bordeaux"></img>
                    <span className="WebLink_16x16_4 window-icon"></span>
                    <span className="Websrch_16x16_4 window-icon "></span>
                    <div className="User5_32x32_4 transform-2x right-16 inline-block vertical-middle"></div>
                    <div className="Awfext326051_32x32_4 transform-2x right-16 inline-block vertical-middle"></div>
                    <span className="Mail_16x16_4 window-icon "></span>
                    <div className="User2_32x32_4 transform-2x right-16 inline-block vertical-middle"></div>
                    <span className="Help_16x16_4 window-icon "></span>
                </div>
                <p className="all-32">
                    {t('splashLoading', this.props.lang)}
                </p>
            </WindowContent>
        </Window>
        </div>
    )
  }
}

export default SplashScreen